// extracted by mini-css-extract-plugin
module.exports = {"messengerHolder":"_1iE0IibqdHDJM92-vyP0IT"};